import Cookies from "universal-cookie";

const cookies = new Cookies()
const COOKIE_NAME = 'userInfo'

export const setUserCookie = (userData) => {
    // console.log("setting cookie",userData)
    cookies.set(COOKIE_NAME, JSON.stringify(userData), {
        path: '/',
        domain: '.expertbunch.com',
        // domain: '.expertbunch.local',
        secure : false,
        sameSite : "Lax"
    })
}

export const removeUserCookie = () => {
    cookies.remove(COOKIE_NAME, {
        path: '/',
        domain: '.expertbunch.com'
        // domain: '.expertbunch.local'
    })}